<template>
<div class="pp-app-container">
    <div :class="{ 'pp-app':1, 'pp-app--popup-open': showSubscribePopup }">
        <div class="pp-main">
            <pp-sidebar :account="account"></pp-sidebar>
            <div class="pp-page-container">
                <div class="pp-navbar">
                    <nav-bar-search></nav-bar-search>
                </div>
                <div @scroll="onScroll" class="pp-page">
                    <router-view></router-view>
                </div>
            </div>
        </div>
        <pp-playbar :enable-flac="flacSupported"
                    :enable-flac-track="flacSupportedTrack"
                    :playing="playback.playing"
                    :playback-position="playback.position"
                    :playback-position-seconds="playback.positionSeconds"
                    :playback-duration="playback.duration"
                    :current-track="playback.track"
                    :queue="queue"
                    :history="history">
        </pp-playbar>

        <div :class="{ 'pp-popup':1, 'pp-popup--visible': showSubscribePopup }">
            <div class="pp-popup__box">
                <div class="pp-popup__title">
                    You've run out of free plays
                </div>
                <div class="pp-popup__message">
                    <p>
                        We hope you've enjoyed trialing our new and improved classical streaming service.
                    </p>
                    <p v-if="!$root.isIos">
                        To get access to <strong>1000+ albums</strong> and <strong>8000+ tracks</strong> by <strong>300+ composers</strong>, please subscribe.
                    </p>
                </div>
                <a v-if="!$root.isIos" href="https://www.pristineclassical.com/pages/player-subscribe" class="pp-popup__button">
                    Subscribe now
                </a>
                <a @click="showSubscribePopup = false" class="pp-popup__button pp-popup__button--secondary">
                    Continue exploring
                </a>
            </div>
            <!--
            <a href="/app/reset">
                DEBUG: reset plays
            </a>
        -->
        </div>
    </div>
</div>
</template>


<script>
import PpSidebar from './PpSidebar.vue';
import PpPlaybar from './PpPlaybar.vue';
import AlbumGrid from './AlbumGrid.vue';
import NavBarSearch from './NavBarSearch.vue';
import EventBus from '../EventBus.js';

export default {
    components: {
        PpSidebar,
        PpPlaybar,
        AlbumGrid,
        NavBarSearch,
    },
    data() {
        return {
            view: 'desktop',
            isIos: false,

            playback: {
                track: null,
                playing: false,
                position: 0,
                positionSeconds: 0,
                duration: 0,
            },
            queue: [],
            history: [],
            playmode: {
                repeat: true,
                shuffle: false
            },
            account: {
                freePlays: 0,
                id: null,
                name: null,
                plan: null,
            },
            flacSupported: true,
            flacSupportedTrack: true,
            format: 'flac',

            showSubscribePopup: false,

            scrollTimeout: false
        };
    },
    computed: {
        canGoBack() {
            console.log(window.history);
            return window.history.length > 2;
        },
        canGoForward() {
            return false;
        }
    },
    methods: {
        onScroll(e) {
            var target = e.target || e.srcElement;

            if (this.scrollTimeout) { return; }
            this.scrollTimeout = true;
            setTimeout(() => {
                this.scrollTimeout = false;
                var fromBottom = target.scrollHeight - target.scrollTop - target.clientHeight;
                EventBus.emit('navigation.scrolling', {
                    fromBottom
                });
            }, 200);

            var fromBottom = target.scrollHeight - target.scrollTop - target.clientHeight;
            EventBus.emit('navigation.scrolling', {
                fromBottom
            });
        }
    }
}
</script>



// WEBPACK FOOTER //
// Root.vue?1399ad0c